// extracted by mini-css-extract-plugin
export default {"inline-loader":"app_inline-loader__jT7K6","spin":"app_spin__ivSCD","base":"app_base__k36Be","with-nav-menu":"app_with-nav-menu__cwy4H","eightshimmer":"app_eightshimmer__CRVl3"};